import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function WhatWeDo() {
  return (
         <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center flex items-center">
         <div className="max-w-4xl mx-auto bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-4 md:p-16">
        <Link
        to={"/"}
          className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
          
        >
          ← Back to Home
        </Link>

        <div className="bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12">
          <h1 className="text-xl md:text-4xl font-bold text-slate-800 mb-8 text-center">
            What We Do
          </h1>

          <p className="text-sm md:text-xl text-slate-700 max-w-4xl mx-auto text-center mb-12 leading-relaxed">
            Management schools teach the science of management to develop senior executives.  
            However, very few have what it takes to become successful leaders.
          </p>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12 mb-12">
            <div>
              <h3 className="text-xl md:text-4xl font-bold text-slate-800 mb-6">
                Our Approach
              </h3>
              <p className="text-slate-700 mb-6 leading-relaxed text-sm">
                We help successful executives and organizations transform themselves 
                through <strong>self and world discovery</strong> to become enlightened 
                leaders and organizations.
              </p>
              <p className="text-slate-700 leading-relaxed text-sm">
                Through an <strong>unconventional learning experience</strong> tailored 
                to the needs of both organizations and individuals, we create an 
                effective development environment combining seminars with 
                individual and group coaching.
              </p>
            </div>

            <div className="space-y-4 md:space-y-6">
              <div className="border-l-4 border-blue-600 pl-6 py-3 bg-blue-50/50 rounded-r-xl">
                <h4 className="font-semibold text-slate-800 mb-2 text-base md:text-lg">
                  Self Discovery
                </h4>
                <p className="text-slate-600 text-sm md:text-base">
                  Understanding personal leadership style and values
                </p>
              </div>
              <div className="border-l-4 border-indigo-600 pl-6 py-3 bg-indigo-50/50 rounded-r-xl">
                <h4 className="font-semibold text-slate-800 mb-2 text-base md:text-lg">
                  World Discovery
                </h4>
                <p className="text-slate-600 text-sm md:text-base">
                  Developing societal and philosophical awareness
                </p>
              </div>
              <div className="border-l-4 border-purple-600 pl-6 py-3 bg-purple-50/50 rounded-r-xl">
                <h4 className="font-semibold text-slate-800 mb-2 text-base md:text-lg">
                  Transformation
                </h4>
                <p className="text-slate-600 text-sm md:text-base">
                  Moving from success to significance
                </p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <Link to="/programs"
     
        className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold hover:shadow-2xl transition-all duration-300 hover:scale-105 inline-flex items-center"
      >
        Explore Our Programs <ChevronRight className="ml-2 w-5 h-5" />
      
    </Link>
          </div>
        </div>
      </div>
    </div>
  );
}